import { useQuery } from '@tanstack/react-query';
import { keyPrefix } from 'providers/QueryProvider';
import restQuery from 'services/rest-query';

export function useHelpscoutSignature(enabled: boolean) {
  return useQuery({
    queryKey: keyPrefix(['help-scout-signature']),
    queryFn: () => restQuery.get(`/api/help/helpscout/signature`),
    staleTime: 10000,
    gcTime: 1000 * 60 * 60 * 3, // 3 hours in milliseconds
    retry: false,
    enabled,
  });
}

export function useHelpscoutMigration(enabled: boolean) {
  return useQuery({
    queryKey: keyPrefix(['help-scout-migration']),
    queryFn: () => restQuery.get(`/api/help/helpscout/migration`),
    staleTime: 10000,
    gcTime: 1000 * 60 * 60 * 3, // 3 hours in milliseconds
    retry: false,
    enabled,
  });
}

export function useHelpscoutPersonalProfile(userID?: string) {
  return useQuery({
    queryKey: keyPrefix(['help-scout-personal-profile', userID]),
    queryFn: () =>
      restQuery.get(`/api/help/helpscout/profile?userID=${userID}`),
    staleTime: 10000,
    gcTime: 1000 * 60 * 60 * 3, // 3 hours in milliseconds
    retry: false,
    enabled: !!userID,
  });
}
